import GraphqlClient from './GraphqlClients';
import gql from 'graphql-tag';

const CredentialMigrationService = () => {
  const gqlClient = GraphqlClient();

  const readinessQuery = gql`
    query CredentialMigrationReadiness($credentialId: String!, $toAccountId: String) {
      readiness: api_credentialMigrationReadiness(
        credentialId: $credentialId
        toAccountId: $toAccountId
      ) {
        credentialId
        username
        infoProvider
        credentialType
        canMigrateAsCredential
        fromAccountId
        fromAccountName
        toAccountId
        toAccountName
        blockers
        readyToMigrate
        establishments {
          id
          number
          status
          conflictingCredential {
            id
            username
            infoProvider
            credentialType
          }
        }
        shops {
          id
          name
          status
          equivalentShopExists
          conflictingEstablishments {
            id
            number
            credentialUsername
            credentialInfoProvider
          }
        }
      }
    }
  `;

  const getQuery = gql`
    query CredentialMigration($id: String!) {
      migration: api_credentialMigration(id: $id) {
        id
        credentialId
        infoProvider
        fromAccountId
        toAccountId
        establishmentIds
        status
        shopMapping {
          fromShopId
          toShopId
          created
        }
        apiStep {
          status
          error
          retryable
        }
        scraperStep {
          status
          error
          retryable
        }
        schedulerStep {
          status
          error
          retryable
        }
        reassignmentStep {
          status
          error
          retryable
        }
        resolvable
        resolvedAt
        events {
          step
          status
          errorMessage
          createdAt
        }
      }
    }
  `;

  const startMutation = gql`
    mutation CredentialMigrationStart($credentialId: String!, $toAccountId: String!) {
      operation: api_credentialMigrationStart(
        credentialId: $credentialId
        toAccountId: $toAccountId
      ) {
        migrationId
        status
        errors
      }
    }
  `;

  const retryMutation = gql`
    mutation CredentialMigrationRetry($migrationId: String!, $steps: [String!]) {
      operation: api_credentialMigrationRetry(migrationId: $migrationId, steps: $steps) {
        ok
        errors
      }
    }
  `;

  const resolveMutation = gql`
    mutation CredentialMigrationResolve($migrationId: String!) {
      operation: api_credentialMigrationResolve(migrationId: $migrationId) {
        ok
        errors
      }
    }
  `;

  return {
    readiness: (credentialId, toAccountId) => {
      return gqlClient
        .query({
          fetchPolicy: 'network-only',
          query: readinessQuery,
          variables: { credentialId, toAccountId: toAccountId || null }
        })
        .then((data) => data.data.readiness)
        .catch((error) => {
          throw error;
        });
    },
    get: (id) => {
      return gqlClient
        .query({
          fetchPolicy: 'network-only',
          query: getQuery,
          variables: { id }
        })
        .then((data) => data.data.migration)
        .catch((error) => {
          throw error;
        });
    },
    start: (credentialId, toAccountId) => {
      return gqlClient
        .mutate({
          mutation: startMutation,
          variables: { credentialId, toAccountId }
        })
        .then((data) => data.data.operation)
        .catch((error) => {
          throw error;
        });
    },
    retry: (migrationId, steps) => {
      return gqlClient
        .mutate({
          mutation: retryMutation,
          variables: { migrationId, steps: steps || null }
        })
        .then((data) => data.data.operation)
        .catch((error) => {
          throw error;
        });
    },
    resolve: (migrationId) => {
      return gqlClient
        .mutate({
          mutation: resolveMutation,
          variables: { migrationId }
        })
        .then((data) => data.data.operation)
        .catch((error) => {
          throw error;
        });
    }
  };
};

export default CredentialMigrationService;
